module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "slide",
    class: {
      active: _vm.isActive
    }
  }, [(_vm.isVideo(_vm.slide)) ? _c('div', {
    staticClass: "slide-inner"
  }, [_c('div', {
    staticClass: "mask"
  }), _vm._v(" "), _c('video', {
    ref: "video",
    attrs: {
      "poster": _vm.slide.poster,
      "autoplay": "",
      "loop": ""
    }
  }, _vm._l((_vm.slide.sources), function(src) {
    return _c('source', {
      attrs: {
        "src": src,
        "type": _vm.getVideoType(src)
      }
    })
  }))]) : _c('div', {
    staticClass: "slide-inner"
  }, [_c('img', {
    attrs: {
      "src": _vm.slide
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-54772acb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/landingPage/Slide.vue
// module id = 677
// module chunks = 0